import { orgGetImage } from "./orgGetImage";
import { handleTable } from "../../../Tools/Requests";
import { checkCurrentUserRights, getRightsData } from "../../../Tools/Tools";
import { parseColumns, ParsedColumn } from "../../GridTools/parseColumnTools";
import { createGrid, createRecordSource, mfDelete, mfEdit } from "../../rcsgrid";
import { isAdminAtom, smetaStore } from "../../../../../atoms";
import { ObjType } from "../../../Tools/Consts";

interface StaffData {
  json?: { Columns: any; Details: any; EditableFields?: string; JSONType: string; ObjType?: string; Rights: string };
  groupID: string;
  setSelectedRecord: (id: string) => void;
  setCountRecords: (count: number) => void;
}

export async function organizationsGrid(grid: createGrid, source: createRecordSource, props: any, data: StaffData) {
  const { json, groupID, setSelectedRecord, setCountRecords } = data;
  const editableFields = json?.EditableFields
    ? json.EditableFields.split(",")
    : ["MNEMOKOD", "CONTRAGENTTYPES", "CONTRAGENTTYPESID", "CONTRAGENTIDENT", "DOCVID", "CLOSEDATE", "CLASSTYPE"];
  if (json) {
    source.rights = getRightsData(json.Rights);
  }
  source.caseSensitive = false;
  const gridObjType = json?.ObjType || props.ObjType;
  const columns = parseColumns(json, { collapsibleField: "Name" });
  grid.setColumns(columns);
  grid.canModify = (flag: number, column: ParsedColumn | undefined, grid: createGrid) => {
    const activeSource: createRecordSource = grid.getActiveSource();
    const checkParentTitle = (parentColumn: ParsedColumn) => {
      return false;
    };
    if (!grid.localCanModify(flag, column, grid)) return false;
    const hasExternalKey = activeSource.getFieldTextSync("ExternalKey") !== "";
    const hasRights =
      column?.fieldName === "ExternalKey"
        ? smetaStore.get(isAdminAtom)
        : checkCurrentUserRights(ObjType.Organization, flag, false);
    if (!hasRights) return false;
    switch (flag) {
      case mfDelete:
        return !hasExternalKey;
      case mfEdit:
        if (
          column &&
          !editableFields.some((field) => field?.toLowerCase() === column.fieldName?.toLowerCase()) &&
          !(column.level === 1 && checkParentTitle(column))
        )
          return !hasExternalKey;
        return true;
      default:
        return true;
    }
  };
  source.onHandleRequest = handleTable({
    Module: props.Module,
    ObjType: gridObjType,
    GroupID: groupID,
    selectedRecordID: props.ObjRef || "0",
    SectionID: props.SectionID,
  });

  source.onRecordIndexChanged = (s: createRecordSource) => {
    setSelectedRecord(s.getFieldTextSync("ID"));
  };

  grid.setImageFields(["CloseDate", "ExternalKey"]);
  source.booksGetImage = orgGetImage;

  await grid.setSource(source);
  await grid.refreshSource(props.ObjRef || "0");
  await grid.updateGridSize();

  setCountRecords(source.recordCount);
  const id = source.getFieldTextSync("ID");
  setSelectedRecord(id);
}
